class Territory {
  static Attitude = {
    Friendly: 4,
    Neutral: 3,
    Suspicious: 2,
    Hostile: 1
  };

  constructor(name, capital, capitalPosition) {
    this.name = name;
    this.capital = capital;
    this.capitalPosition = capitalPosition;
    this.relation = Math.floor(Math.random() * 100);
  }

  attitude(charisma) {
    // Apply a diminishing returns formula to charisma impact
    const adjustedRelation = this.relation + Math.log10(charisma + 1) * 20;
    // Ensuring the adjusted relation stays within bounds [0, 100]
    const boundedRelation = Math.min(Math.max(adjustedRelation, 0), 100);

    if (boundedRelation < 25) return Territory.Attitude.Hostile;
    if (boundedRelation < 50) return Territory.Attitude.Suspicious;
    if (boundedRelation < 75) return Territory.Attitude.Neutral;
    return Territory.Attitude.Friendly;
  }
}

export default Territory;
